export default function stopLoading(call) {
    return {
        type: stopLoading.type,
        payload: call,
    };
}

stopLoading.type = 'STOP_LOADING';
